import styled from "styled-components";
import themes from "@/styles/themes";

const subscriptionDetailsValue = styled.p`
  margin: 5px 0;
  font-size: 14px !important;
  text-align: right !important;
  color: #2c2c2c;
  font-weight: 600;
  .valor {
    color: ${themes.estadao};
    font-size: 20px;
    font-weight: bold;
  }
  span {
    color: black;
    font-size: 20px;
  }

  &.descricao {
    color: black;
    font-weight: 400;
  }
`

export default subscriptionDetailsValue